var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApillowcasetwopillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101.23pt",
    height: "56.511pt",
    viewBox: "0 0 101.23 56.511",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.839 -467.69)",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 3.864,
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m488.44 956.99 384.88-143.05s30.234-13.086 60.742 0.85938l511.99 233.95"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m459.69 981.4v-94.102c0.78125-7.2266 8.2422-15.586 28.75-24.414l384.92-146.21-0.0391-0.11719s32.422-11.055 62.93 2.8906"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m488.44 956.99c-61.875 26.68-4.9219 48.789-4.9219 48.789l527.23 204.92s23.672 10.234 53.086-0.2734l386.21-121.56s46.25-17.148-3.9844-40.117"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1469.4 1071.7v-88.867c-0.8203-5.8594-6.9141-13.789-23.32-21.289l-511.95-243.16"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.839 -467.69)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.84 483.57s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.84 483.57s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.84 483.57s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.84 483.57s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.84 483.57s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.84 483.57s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 475.29s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 475.29s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 475.29s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 475.29s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 475.29s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 475.29s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.04688 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.04688 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.04688 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.04688 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.0469 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m98.001 15.876s-2.5703 4.1445-8.207 7.8242l-2.457-2.0156s7.0586-5.668 7.4883-5.7188c0.42969-0.04688 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#6b645b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#6b645b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#6b645b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#6b645b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.839 -467.69)",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1232.1 1200.3s-25.703-41.445-82.031-78.203l-24.57 20.117s70.547 56.719 74.844 57.188c4.2969 0.5078 31.758 0.8984 31.758 0.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1438.4 1117.5s-25.703-41.445-82.07-78.242l-24.57 20.156s70.586 56.68 74.883 57.188c4.2969 0.4688 31.758 0.8984 31.758 0.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1438.4 1117.5s-25.703-41.445-82.07-78.242l-24.57 20.156s70.586 56.68 74.883 57.188c4.2969 0.4688 31.758 0.8984 31.758 0.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1438.4 1117.5s-25.703-41.445-82.07-78.242l-24.57 20.156s70.586 56.68 74.883 57.188c4.2969 0.4688 31.758 0.8984 31.758 0.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1438.4 1117.5s-25.703-41.445-82.07-78.242l-24.57 20.156s70.586 56.68 74.883 57.188c4.2969 0.4688 31.758 0.8984 31.758 0.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1438.4 1117.5s-25.703-41.445-82.07-78.242l-24.57 20.156s70.586 56.68 74.883 57.188c4.2969 0.4688 31.758 0.8984 31.758 0.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1438.4 1117.5s-25.703-41.445-82.07-78.242l-24.57 20.156s70.586 56.68 74.883 57.188c4.2969 0.4688 31.758 0.8984 31.758 0.8984z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.0508 3.1758-0.0898 3.1758-0.0898",
    fill: "#ddd9ce"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m77.371 7.5956s-2.5703 4.1445-8.2031 7.8203l-2.457-2.0117s7.0547-5.6719 7.4844-5.7188c0.42969-0.05078 3.1758-0.08984 3.1758-0.08984z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m69.031 15.916 0.95703-1.7852c0.19141-0.35156 0.46484-0.69922 0.81641-1.0234l3.5625-3.2734c0.34766-0.32031 0.76562-0.61328 1.2266-0.85547l2.3359-1.2422c0.34375-0.18359 0.38281-0.50391 0.0742-0.57812l-3.1367-0.73438-11.809-4.6719-2.3672-1.4414c-0.23438-0.14453-0.70703 4e-3 -0.84766 0.26953l-0.90234 1.6875c-0.1875 0.35156-0.46484 0.69922-0.8125 1.0195l-3.7461 3.4414c-0.34766 0.32422-0.76562 0.61328-1.2266 0.85938l-2.207 1.1719c-0.34375 0.18359-0.38672 0.50391-0.07422 0.57422l2.6211 0.61719c0.16016 0.0391 0.3125 0.082 0.45703 0.14062l11.855 4.6914c0.14453 0.0586 0.27734 0.125 0.40234 0.19922l1.9766 1.2031c0.23437 0.14453 0.70312-4e-3 0.84375-0.26953",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m69.031 15.916 0.95703-1.7852c0.19141-0.35156 0.46484-0.69922 0.81641-1.0234l3.5625-3.2734c0.34766-0.32031 0.76562-0.61328 1.2266-0.85547l2.3359-1.2422c0.34375-0.18359 0.38281-0.50391 0.07422-0.57812l-3.1367-0.73438-11.809-4.6719-2.3672-1.4414c-0.23438-0.14453-0.70703 0.0039-0.84766 0.26953l-0.90234 1.6875c-0.1875 0.35156-0.46484 0.69922-0.8125 1.0195l-3.7461 3.4414c-0.34766 0.32422-0.76562 0.61328-1.2266 0.85938l-2.207 1.1719c-0.34375 0.18359-0.38672 0.50391-0.07422 0.57422l2.6211 0.61719c0.16016 0.03906 0.3125 0.08203 0.45703 0.14062l11.855 4.6914c0.14453 0.05859 0.27734 0.125 0.40234 0.19922l1.9766 1.2031c0.23438 0.14453 0.70312-0.0039 0.84375-0.26953z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m69.031 15.916 0.95703-1.7852c0.19141-0.35156 0.46484-0.69922 0.81641-1.0234l3.5625-3.2734c0.34766-0.32031 0.76562-0.61328 1.2266-0.85547l2.3359-1.2422c0.34375-0.18359 0.38281-0.50391 0.0742-0.57812l-3.1367-0.73438-11.809-4.6719-2.3672-1.4414c-0.23438-0.14453-0.70703 4e-3 -0.84766 0.26953l-0.90234 1.6875c-0.1875 0.35156-0.46484 0.69922-0.8125 1.0195l-3.7461 3.4414c-0.34766 0.32422-0.76562 0.61328-1.2266 0.85938l-2.207 1.1719c-0.34375 0.18359-0.38672 0.50391-0.07422 0.57422l2.6211 0.61719c0.16016 0.0391 0.3125 0.082 0.45703 0.14062l11.855 4.6914c0.14453 0.0586 0.27734 0.125 0.40234 0.19922l1.9766 1.2031c0.23437 0.14453 0.70312-4e-3 0.84375-0.26953",
    fill: "#ddd9ce"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m69.031 15.916 0.95703-1.7852c0.19141-0.35156 0.46484-0.69922 0.81641-1.0234l3.5625-3.2734c0.34766-0.32031 0.76562-0.61328 1.2266-0.85547l2.3359-1.2422c0.34375-0.18359 0.38281-0.50391 0.07422-0.57812l-3.1367-0.73438-11.809-4.6719-2.3672-1.4414c-0.23438-0.14453-0.70703 0.0039-0.84766 0.26953l-0.90234 1.6875c-0.1875 0.35156-0.46484 0.69922-0.8125 1.0195l-3.7461 3.4414c-0.34766 0.32422-0.76562 0.61328-1.2266 0.85938l-2.207 1.1719c-0.34375 0.18359-0.38672 0.50391-0.07422 0.57422l2.6211 0.61719c0.16016 0.03906 0.3125 0.08203 0.45703 0.14062l11.855 4.6914c0.14453 0.05859 0.27734 0.125 0.40234 0.19922l1.9766 1.2031c0.23438 0.14453 0.70312-0.0039 0.84375-0.26953z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m89.661 23.876 0.95312-1.7852c0.19141-0.35547 0.46484-0.69922 0.81641-1.0234l3.5625-3.2734c0.35156-0.32422 0.76562-0.61328 1.2266-0.85938l2.3359-1.2383c0.34375-0.18359 0.38672-0.50391 0.0742-0.57812l-3.1367-0.73438-11.809-4.6719h4e-3l-2.3711-1.4414c-0.23438-0.14453-0.70312 4e-3 -0.84375 0.26953l-0.90625 1.6875c-0.1875 0.35156-0.46484 0.69922-0.8125 1.0195l-3.7461 3.4414c-0.34766 0.32031-0.76562 0.61328-1.2266 0.85938l-2.207 1.1719c-0.34375 0.18359-0.38281 0.5-0.0703 0.57422l2.6172 0.61719c0.16016 0.0352 0.31641 0.082 0.45703 0.14062l11.855 4.6914c0.14453 0.0586 0.28125 0.125 0.40234 0.19922l1.9766 1.2031c0.23437 0.14453 0.70703-8e-3 0.84766-0.26953",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m89.661 23.876 0.95312-1.7852c0.19141-0.35547 0.46484-0.69922 0.81641-1.0234l3.5625-3.2734c0.35156-0.32422 0.76562-0.61328 1.2266-0.85938l2.3359-1.2383c0.34375-0.18359 0.38672-0.50391 0.07422-0.57812l-3.1367-0.73438-11.809-4.6719h0.0039l-2.3711-1.4414c-0.23438-0.14453-0.70312 0.0039-0.84375 0.26953l-0.90625 1.6875c-0.1875 0.35156-0.46484 0.69922-0.8125 1.0195l-3.7461 3.4414c-0.34766 0.32031-0.76562 0.61328-1.2266 0.85938l-2.207 1.1719c-0.34375 0.18359-0.38281 0.5-0.07032 0.57422l2.6172 0.61719c0.16016 0.03516 0.31641 0.08203 0.45703 0.14062l11.855 4.6914c0.14453 0.05859 0.28125 0.125 0.40234 0.19922l1.9766 1.2031c0.23438 0.14453 0.70703-0.0078 0.84766-0.26953z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m89.661 23.916 0.95703-1.7852c0.1875-0.35156 0.46484-0.69922 0.8125-1.0195l3.5625-3.2773c0.35156-0.32031 0.76562-0.61328 1.2305-0.85547l2.332-1.2422c0.34375-0.18359 0.38672-0.5 0.0742-0.57422l-3.1328-0.73828-4e-3 4e-3 -11.809-4.6758h4e-3l-2.3672-1.4414c-0.23437-0.14453-0.70703 8e-3 -0.84766 0.26953l-0.90234 1.6875c-0.19141 0.35156-0.46484 0.69922-0.81641 1.0234l-3.7422 3.4414c-0.35156 0.32031-0.76562 0.60938-1.2305 0.85547l-2.2031 1.1719c-0.34375 0.18359-0.38672 0.50391-0.0742 0.57812l2.6172 0.61328c0.16406 0.0391 0.31641 0.0859 0.46094 0.14062l11.855 4.6953c0.14453 0.0547 0.27734 0.12109 0.39844 0.19531l1.9766 1.207c0.23438 0.14062 0.70703-8e-3 0.84766-0.27344",
    fill: "#ddd9ce"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m89.661 23.916 0.95703-1.7852c0.1875-0.35156 0.46484-0.69922 0.8125-1.0195l3.5625-3.2773c0.35156-0.32031 0.76562-0.61328 1.2305-0.85547l2.332-1.2422c0.34375-0.18359 0.38672-0.5 0.07422-0.57422l-3.1328-0.73828-0.0039 0.0039-11.809-4.6758h0.0039l-2.3672-1.4414c-0.23438-0.14453-0.70703 0.0078-0.84766 0.26953l-0.90234 1.6875c-0.19141 0.35156-0.46484 0.69922-0.81641 1.0234l-3.7422 3.4414c-0.35156 0.32031-0.76562 0.60938-1.2305 0.85547l-2.2031 1.1719c-0.34375 0.18359-0.38672 0.50391-0.07422 0.57812l2.6172 0.61328c0.16406 0.03906 0.31641 0.08593 0.46094 0.14062l11.855 4.6953c0.14453 0.05468 0.27734 0.12109 0.39844 0.19531l1.9766 1.207c0.23438 0.14062 0.70703-0.0078 0.84766-0.27344z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApillowcasetwopillow);
export default __webpack_public_path__ + "static/media/apillowcasetwopillow.baf7495c685c903529f62340bb925833.svg";
export { ForwardRef as ReactComponent };